import { SuspenseWrapper } from 'app/agriculture/components/SuspenseWrapper/SuspenseWrapper';
import { TimelineSkeleton } from 'app/agriculture/AgTimeline/components/TimelineSkeleton/TimelineSkeleton';
import { TimelineTaskRows } from 'app/agriculture/AgTimeline/components/TimelineRows/TimelineTaskRows/TimelineTaskRows';

export function TimelineRows() {
    return (
        <div className="TimelineContent__rows">
            <SuspenseWrapper loadingComponent={<TimelineSkeleton />}>
                <TimelineTaskRows />
            </SuspenseWrapper>
        </div>
    );
}
